import axios from 'axios'
import {
  isEmpty
} from '@/js/util'
import util from '../util/util'
// import { Message, MessageBox } from 'element-ui'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_CLIENT_SERVER_URL, // api的base_url
  timeout: 30000 // 请求超时时间
})
function setToken (options) {
  let userInfo = util.getToken()
  let baseHeader = {}

  if (userInfo && !isEmpty(userInfo.accessToken)) {
    baseHeader = {
      'X-Token': userInfo.accessToken,
      'X-Language': getLanguage()
    }
    options['headers'] = baseHeader
  }
  return options
}
function getLanguage () {
  let locale = util.getProfile().locale || 'cn'
  switch (locale) {
    case 'zh-hant':
      return 'hk'
    case 'zh-hans':
      return 'cn'
    default:
      return 'cn'
  }
}
// request拦截器
service.interceptors.request.use(config => {
  if (config.method.toLowerCase() === 'get' && config.data) {
    config.params = config.data
    delete config.data
  }
  console.log(config) // for debug
  setToken(config)
  return config
}, error => {
  console.log(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    console.log(response.data)
    const res = response.data
    if (res.code !== 200) {
      // Message({
      //   message: res.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        //   confirmButtonText: '重新登录',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch('FedLogOut').then(() => {
        //     location.reload() // 为了重新实例化vue-router对象 避免bug
        //   })
        // })
      }
      return null
    } else {
      return response.data
    }
  },
  error => {
    if (error.message === 'Network Error' && error.config.url.endsWith('/license')) {
      // Message({
      //   message: '无法连接到本地代理程序，请确认代理程序是否运行正常！',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
    } else {
      console.log(error + ' ' + error.config.url) // for debug
      // Message({
      //   message: error.message + ' ' + error.config.url,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
    }
    return Promise.reject(error.data || error)
  }
)
export default service
